
import {
  Row,
  Col,
  Button,
  ButtonGroup,
  FormGroup,
  FormControl,
  HelpBlock,
}from 'react-bootstrap';

import {
  Label,
  Audio,
  ListView,
}from '../';

import { COLOR, MODES } from '../../const';

var React = require('react');
var Radium = require('radium');
var FontAwesome = require('react-fontawesome');
var HelperScripts = require('../../utils/HelperScripts.js');

class TestAct extends React.Component {
  render() {
    return(
      <div>
        <Row>
          <ListView {...this.props}>
            {this.props.progressList.map(item => {
              return(
              <TestItem
                key={item.word}
                item = {item}
                isCorrect = {item.isCorrect}
                {...this.props}
              />
            )})}
          </ListView>
        </Row>
      </div>
    )
  }
}

class TestItem extends React.Component {

  constructor(props){
    super(props);

    this.state = {
      input: "",
      width: '0',
      buttonGrpWidth: '0',
    };
  }

  componentDidMount(){
    //console.log(this.state.options.length);
    //Extra props from item
    const {input, validationInput} = this.props.item.props;

    /*  Previous Input  */
    if (input){
      //Set input field to previous input
      this.setState({
        input: input,
      })
    }
    /* Previous validation state of input field */
    if (validationInput){
      this.setState({
        validationInput: validationInput,
      })
    }
    /*  Screen res  */
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    /*  ----------  */

  }

  componentWillUnmount(){
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {


    this.setState({
      width: window.innerWidth,
    });
  }

  playAudio = () => {
    this.audio.onPlay();
  }

  setRef = (input) =>{
    this.wordInput = input;
  }

  handleChange = (e) => {
    this.setState({
      input: e.target.value,
    })
  }

  onClickVirtualButton = (char) => {
    this.setState((prevState, prevProps) => ({
      input: prevState.input + char,
    }))
  }

  checkAnswer = () => {

    if (!this.state.input) {
      this.setState({
        validationInput: "warning",
      });
      return;
    }

    if (this.state.input === this.props.item.word){
      //Done right
      this.props.updateProgressList({
        word: this.props.item.word,
        isCorrect: true,
        wasChecked: true,
        //Extr props
        input: this.state.input,
        validationInput: "success",
      })
      this.setState({
        validationInput: "success",
      });
    }else{
      //Done right
      this.props.updateProgressList({
        word: this.props.item.word,
        isCorrect: false,
        wasChecked: true,
        //Extr props
        input: this.state.input,
        validationInput: "error",
      })
      this.setState({
        validationInput: "error",
      });
    }
  }

  render() {

    const {container, header, sentence, footer, button, check} = styles.item.base;
    const {container: containerCorr , sentence: sentenceCorr} = styles.item.correct;
    const {container: containerNorm , sentence: sentenceNorm} = styles.item.notChecked;

    const {item, mode, toggleAudio, isAudioPlaying, updateProgressList, isCorrect, setAudioFalse, id} = this.props;
    const {wasChecked} = this.props.item;

    let checkButtonStyle;

    if (isCorrect && wasChecked){
      checkButtonStyle = "success";
    }else if (!isCorrect && wasChecked){
      checkButtonStyle = "danger";
    }else {
      checkButtonStyle = "info";
    }

    return (
      <Col
        xs={12}
        md={6}
        style={
          styles.item.base
        }
      >
        <div style={[container, isCorrect && containerCorr, !isCorrect && containerNorm]}>
          <div style={header}>
            <Label color="white" italic text={"Word Sound"}/>
            <Button
              bsStyle="success"
              bsSize="lg"
              //block
              onClick={this.playAudio}
              style={button}
               >
              <FontAwesome
                name="volume-up"
                inverse={true}
                size="lg"
              />
            </Button>
            <Label color="white" italic text={"Special Letters"}/>
            <VirtualButtons
              currWidth={this.state.width}
              maxResW={500}
              ref={ (VirtualButtons) => this.virtualButtons = VirtualButtons}
              onClick={this.onClickVirtualButton}
              disabled={(wasChecked) ? true : false}
            />
            <Label color="white" italic text={"Word Field"}/>
            <WordInput
              onChange={this.handleChange}
              setRef={this.setRef}
              disabled={(wasChecked) ? true : false}
              inputVal={this.state.input}
              validationState={this.state.validationInput}
            />
          </div>
          <div style={footer}>
            <Button
              onClick = {(wasChecked) ? null : this.checkAnswer}
              bsSize = "large"
              bsStyle= {checkButtonStyle}
            >
              Check Answer
            </Button>
          </div>
          <Audio
            mode={mode}
            item={item}
            onEndedCallback={(!isCorrect) ? this.onEndedCallback : null}
            isAudioPlaying={isAudioPlaying}
            toggleAudio={toggleAudio}
            setAudioFalse={setAudioFalse}
            ref={(Audio) => {this.audio = Audio;}}
          />
        </div>
        <ProgressCounter itemNum={this.props.progressList.indexOf(item) + 1} maxNum={this.props.progressList.length} />
      </Col>
      )
  }
}

let WordInput = ({setRef, onChange, label = "Label", inputVal, validationState, disabled}) => {
  return(
    <div style={styles.input}>
      <FormGroup bsSize="large" validationState={validationState}>
        <FormControl type="text" disabled={disabled} onChange={onChange} value={inputVal} inputRef={setRef} placeholder="word..." />
        <FormControl.Feedback />
        {(validationState === "warning") &&
          <HelpBlock style={{color: COLOR.white}}>The field cannot be empty.</HelpBlock>
        }
      </FormGroup>
    </div>
  )
}

let VirtualButtons = ({handleClick, currWidth, maxResW, onClick, disabled}) => {

  let id = 0;

  return(
    <ButtonGroup
      block={(currWidth <= maxResW) ? true : false}
      vertical={(currWidth <= maxResW) ? true : false}
      style={styles.buttonGroup}>
      <Button bsSize="large" bsStyle="primary" onClick={() => onClick('á')} disabled={disabled}>á</Button>
      <Button bsSize="large" bsStyle="primary" onClick={() => onClick('é')} disabled={disabled}>é</Button>
      <Button bsSize="large" bsStyle="primary" onClick={() => onClick('í')} disabled={disabled}>í</Button>
      <Button bsSize="large" bsStyle="primary" onClick={() => onClick('ó')} disabled={disabled}>ó</Button>
      <Button bsSize="large" bsStyle="primary" onClick={() => onClick('ú')} disabled={disabled}>ú</Button>
      <Button bsSize="large" bsStyle="primary" onClick={() => onClick('ñ')} disabled={disabled}>ñ</Button>
    </ButtonGroup>
  )
}

let ProgressCounter = ({itemNum = -1, maxNum = 1}) => (
  <div style={styles.progressCounter}>
    {`Progress: ${itemNum} / ${maxNum}`}
  </div>
)

TestItem = Radium(TestItem);
WordInput = Radium(WordInput);
VirtualButtons = Radium(VirtualButtons);


const styles = {
  item: {
    base:{
      textAlign: 'center',
      marginBottom: '2rem',


      container: {
        borderRadius: '10px',
        minHeight: '300px',
      },
      header: {
        padding: '2rem',
      },
      sentence: {
        backgroundColor: COLOR.white,
        padding: '2rem 1rem',
        minHeight: '150px',

        text: {
          fontSize: '21px',
          fontWeight: '300',
        },
      },
      word: {
        color: COLOR.white,
        fontSize: '30px',
      },
      footer: {
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        padding: '2rem',
      },
      button:{
        minWidth: '80%',
        marginBottom: '2rem',
      },
      check: {
        minWidth: '150px',
      },
      option: {
        color: COLOR.blue,
      },
      optionBtn: {
        backgroundColor: COLOR.white,
      },
    },
    notChecked: {
      container: {
        borderColor: COLOR.blue,
        backgroundColor: COLOR.blue,
      },
    },
    correct: {
      container: {
        borderColor: COLOR.green,
        backgroundColor: COLOR.green,
      },
      option: {
        color: COLOR.white,
      },
      optionBtn: {
        backgroundColor: COLOR.green,
      },
    },
    incorrect: {
      container: {
        borderColor: COLOR.red,
        backgroundColor: COLOR.red,
      },
      option: {
        color: COLOR.red,
      },
      optionBtn: {
        backgroundColor: COLOR.white,
      },
    }
  },
  input:{
    padding: '1rem 2rem',
  },
  progressCounter: {
    padding: '3rem 3rem 1rem 3rem',
    fontSize: '18px',
  }

}

export default Radium(TestAct);



// WEBPACK FOOTER //
// ./src/comp/Activities/TestAct.js